import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {QuestionsComponent} from './containers/questions/questions.component';
import {QuestionCategoriesComponent} from './containers/question-categories/question-categories.component';
import {RoundOfQuestionsComponent} from './containers/round-of-questions/round-of-questions.component';
import {FormsComponent} from './containers/forms/forms.component';
import {UploadFormsComponent} from './components/forms/upload-forms/upload-forms.component';
import {EditFormsAdminComponent} from './components/forms/edit-forms/edit-forms-admin.component';
import {EditFormsComponent} from '../intelligence-data-entry/components/edit-forms/edit-forms.component';
import {IntelligenceReportingGuard} from './guards/intelligence-reporting.guard';

const routes: Routes = [
  {
    path: 'intelligencereporting', canActivate: [IntelligenceReportingGuard],
    children: [
      {path: 'questions', children: [
          {path: 'all', component: QuestionsComponent},
          {path: 'questioncategories', component: QuestionCategoriesComponent}
        ]
      },
      {path: 'roundofquestions', children: [
          {path: '', component: RoundOfQuestionsComponent},
          {path: ':id/:year/preview', component: EditFormsComponent}
        ]
      },
      {path: 'forms', children: [
          {path: 'list', component: FormsComponent },
          {path: ':level/:name/:roundOfQuestionsId/:userId', component: EditFormsAdminComponent },
          {path: 'upload', component: UploadFormsComponent }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntelligenceReportingRoutingModule { }
